import React from 'react'
import { useTranslation } from 'react-i18next'
import { tr } from 'i18n'
import './TransportTableHeading.scss'

export const BASE_DRIVER_COLUMNS = ['Автомобиль', 'Водитель', 'Поездки', 'Статус', 'Синхронизация', 'Действия']

export default function TransportTableHeading() {
  useTranslation()
  return <tr className="transport-table-heading">
    <th>{tr('Автомобиль')}</th><th>{tr('Водитель')}</th><th>№</th><th>{tr('Телефон')}</th>
    <th>{tr('Дополнительный ном.тел.')}</th><th>{tr('Модель машины')}</th><th>{tr('UID')}</th>
    <th>{tr('QR строка')}</th><th>{tr('Фото')}</th><th>{tr('QR (изображение)')}</th><th>{tr('Создано')}</th>
    <th>{tr('Статус')}</th><th>{tr('Статус машины')}</th><th>{tr('Синхронизация')}</th><th>{tr('Действия')}</th>
  </tr>
}
